
/**
 * Baidu 自定义搜索
 */
export default {
  props: {
    siteDomainName: String,
  },
  computed: {
    getSiteDomainName(): string {
      return this.siteDomainName || location.host || document.domain;
    },
  },
};
